import { useLanguage } from '@/lib/i18n';

interface AccordionItem {
  id: string;
  title: string;
  vermittlung: string;
  anu: string;
  hinweis?: string;
}

const AGBComparisonLayout = () => {
  const { lang } = useLanguage();

  const content: Record<string, AccordionItem[]> = {
    de: [
      {
        id: 'geltungsbereich',
        title: '1. Geltungsbereich',
        vermittlung:
          'Diese AGB gelten für Personalvermittlung (§§ 652 ff. BGB) zwischen Austrojob GmbH (ViaMedica Balkan) und Arbeitgebern. Für Pflegekräfte ist die Nutzung kostenfrei.',
        anu: 'Diese AGB gelten für Arbeitnehmerüberlassung nach AÜG. Abweichende Bedingungen gelten nur bei schriftlicher Zustimmung.',
      },
      {
        id: 'leistungsgegenstand',
        title: '2. Leistungsgegenstand',
        vermittlung:
          'Identifikation, Vorauswahl, Bewerberprofile, Koordination von Gesprächen, Unterstützung bis zum Arbeitsvertrag.',
        anu: 'Überlassung von Pflegekräften im Rahmen des AÜG. Arbeitnehmer bleiben Angestellte des Vermittlers, Arbeitgeber erhält zeitlich befristetes Nutzungsrecht.',
        hinweis:
          'Die Arbeitnehmerüberlassung erfolgt ausschließlich auf Grundlage der Erlaubnis nach §1 AÜG, erteilt durch die Agentur für Arbeit Nürnberg.',
      },
      {
        id: 'zustandekommen',
        title: '3. Zustandekommen des Erfolgs',
        vermittlung:
          'Erfolg liegt vor, sobald ein Arbeitsvertrag oder Beschäftigungsverhältnis zustande kommt – auch zeitversetzt oder über verbundene Unternehmen.',
        anu: 'Erfolg liegt vor, sobald ein Überlassungsvertrag geschlossen und die Pflegekraft eingesetzt wird.',
      },
      {
        id: 'verguetung',
        title: '4. Vergütung',
        vermittlung: 'Provision laut Vertrag, fällig 30 Tage nach Abschluss. Keine Rückerstattung.',
        anu: 'Überlassungsentgelt nach geleisteten Stunden, monatliche Abrechnung.',
      },
      {
        id: 'pflichten-arbeitgeber',
        title: '5. Pflichten des Arbeitgebers',
        vermittlung:
          'Bereitstellung vollständiger Informationen, Mitteilung über Vertragsabschlüsse, keine Weitergabe von Bewerberprofilen.',
        anu: 'Einsatz nur im Rahmen des AÜG, Einhaltung gesetzlicher Vorgaben, Arbeitsschutz und Weisungsrecht.',
      },
      {
        id: 'pflichten-vermittler',
        title: '6. Pflichten des Vermittlers',
        vermittlung:
          'DSGVO-konforme Datenverarbeitung, Vorschlag geeigneter Pflegekräfte, keine Garantie für Qualifikation oder Verbleib.',
        anu: 'Rechtssichere Durchführung der ANÜ (inkl. Erlaubnis nach §1 AÜG), ordnungsgemäße Entlohnung und Betreuung der überlassenen Arbeitnehmer.',
      },
      {
        id: 'haftung',
        title: '7. Haftung',
        vermittlung:
          'Haftung nur bei Vorsatz oder grober Fahrlässigkeit, keine Haftung für Arbeitsleistung oder entgangenen Gewinn.',
        anu: 'Haftung nur bei Vorsatz oder grober Fahrlässigkeit, keine Haftung für Ausfälle oder arbeitsvertragliche Probleme.',
      },
      {
        id: 'datenschutz',
        title: '8. Datenschutz',
        vermittlung:
          'Verarbeitung personenbezogener Daten ausschließlich zur Durchführung gemäß DSGVO und BDSG.',
        anu: 'Verarbeitung personenbezogener Daten ausschließlich zur Durchführung gemäß DSGVO und BDSG.',
      },
      {
        id: 'schlussbestimmungen',
        title: '9. Schlussbestimmungen',
        vermittlung:
          'Änderungen nur schriftlich. Salvatorische Klausel. Deutsches Recht. Gerichtsstand Freilassing.',
        anu: 'Änderungen nur schriftlich. Salvatorische Klausel. Deutsches Recht. Gerichtsstand Freilassing.',
      },
    ],
    bs: [
      {
        id: 'geltungsbereich',
        title: '1. Primjena',
        vermittlung:
          'Ovi OPP važi za posredovanje u zapošljavanju (§§ 652 ff. BGB) između Austrojob GmbH (ViaMedica Balkan) i poslodavaca. Korišćenje je besplatno za medicinske radnike.',
        anu: 'Ovi OPP važi za pozajmljivanje radnika prema AÜG. Odstupajući uslovi važe samo sa pismenom saglasnoscu.',
      },
      {
        id: 'leistungsgegenstand',
        title: '2. Predmet usluge',
        vermittlung:
          'Identificiranje, predbor, profili kandidata, koordinacija razgovora, podrška do zaključenja ugovora o radu.',
        anu: 'Pozajmljivanje medicinskih radnika u skladu sa AÜG. Zaposleni ostaju zaposleni Vermittlera, poslodavac dobija vremenski ograničeno pravo korišćenja.',
        hinweis:
          'Pozajmljivanje radnika vrši se isključivo na osnovu dozvole prema §1 AÜG, izdane od Agenture za rad Nürnberg.',
      },
      {
        id: 'zustandekommen',
        title: '3. Nastanak usluge',
        vermittlung:
          'Usluga nastaje čim se zaključi ugovor o radu ili radni odnos – čak i sa vremenskim razmakom ili preko povezanih preduzeća.',
        anu: 'Usluga nastaje čim se zaključi ugovor o pozajmljivanju i zaposleni počne s radom.',
      },
      {
        id: 'verguetung',
        title: '4. Naknada',
        vermittlung: 'Provizija prema ugovoru, dospeva 30 dana nakon zaključenja. Bez povraćaja.',
        anu: 'Naknada za pozajmljivanje po odrađenim satima, mesečna obračunavanje.',
      },
      {
        id: 'pflichten-arbeitgeber',
        title: '5. Obaveze poslodavca',
        vermittlung:
          'Pružanje potpunih informacija, obaveštavanje o zaključenju ugovora, bez dalje prosledjivanja profila kandidata.',
        anu: 'Korišćenje samo u okviru AÜG, poštovanje zakonskih odredbi, zaštita pri radu i pravo instrukcije.',
      },
      {
        id: 'pflichten-vermittler',
        title: '6. Obaveze posredovatelja',
        vermittlung:
          'Obrada podataka prema GDPR, predlog odgovarajućih medicinskih radnika, bez garancije za kvalifikaciju ili zadržavanje.',
        anu: 'Pravno sigurna provedba pozajmljivanja (uključujući dozvolu prema §1 AÜG), pravilna isplata i briga o pozajmljenim radnicima.',
      },
      {
        id: 'haftung',
        title: '7. Odgovornost',
        vermittlung:
          'Odgovornost samo za nameru ili veliku nepažnju, bez odgovornosti za radnu uspešnost ili izgubljenu dobit.',
        anu: 'Odgovornost samo za nameru ili veliku nepažnju, bez odgovornosti za izostanke ili probleme u radnom odnosu.',
      },
      {
        id: 'datenschutz',
        title: '8. Zaštita podataka',
        vermittlung: 'Obrada ličnih podataka isključivo za sprovođenje prema GDPR i BDSG.',
        anu: 'Obrada ličnih podataka isključivo za sprovođenje prema GDPR i BDSG.',
      },
      {
        id: 'schlussbestimmungen',
        title: '9. Završne odredbe',
        vermittlung: 'Izmene samo pismeno. Spasilačka klauzula. Nemački zakon. Nadležnost Freilassing.',
        anu: 'Izmene samo pismeno. Spasilačka klauzula. Nemački zakon. Nadležnost Freilassing.',
      },
    ],
    en: [
      {
        id: 'geltungsbereich',
        title: '1. Scope',
        vermittlung:
          'These Terms apply to recruitment services (§§ 652 ff. BGB) between Austrojob GmbH (ViaMedica Balkan) and employers. Nursing professionals use the service free of charge.',
        anu: 'These Terms apply to temporary staffing according to the AÜG. Deviating conditions apply only with written consent.',
      },
      {
        id: 'leistungsgegenstand',
        title: '2. Scope of Services',
        vermittlung:
          'Identification, pre-selection, candidate profiles, coordination of interviews, support through employment contract conclusion.',
        anu: 'Provision of nursing professionals under AÜG. Employees remain employed by the provider; employer receives time-limited usage rights.',
        hinweis:
          'Temporary staffing is provided exclusively based on the license according to §1 AÜG, issued by the employment agency Nuremberg.',
      },
      {
        id: 'zustandekommen',
        title: '3. Service Completion',
        vermittlung:
          'Service is complete once an employment contract or employment relationship is established – even with a time delay or through affiliated companies.',
        anu: 'Service is complete once a staffing agreement is signed and the professional begins work.',
      },
      {
        id: 'verguetung',
        title: '4. Compensation',
        vermittlung: 'Commission according to contract, due 30 days after completion. No refunds.',
        anu: 'Staffing fee based on hours worked, monthly invoicing.',
      },
      {
        id: 'pflichten-arbeitgeber',
        title: '5. Employer Obligations',
        vermittlung:
          'Provision of complete information, notification of contract conclusion, no sharing of candidate profiles.',
        anu: 'Use only within AÜG scope, compliance with legal requirements, occupational safety and instruction rights.',
      },
      {
        id: 'pflichten-vermittler',
        title: '6. Provider Obligations',
        vermittlung:
          'GDPR-compliant data processing, recommendation of qualified professionals, no guarantee of qualifications or retention.',
        anu: 'Legally compliant staffing execution (including AÜG license §1), proper compensation and care of provided staff.',
      },
      {
        id: 'haftung',
        title: '7. Liability',
        vermittlung:
          'Liability only for intent or gross negligence, no liability for work performance or lost profits.',
        anu: 'Liability only for intent or gross negligence, no liability for absences or employment-related issues.',
      },
      {
        id: 'datenschutz',
        title: '8. Data Protection',
        vermittlung: 'Processing of personal data exclusively for performance in accordance with GDPR and BDSG.',
        anu: 'Processing of personal data exclusively for performance in accordance with GDPR and BDSG.',
      },
      {
        id: 'schlussbestimmungen',
        title: '9. Final Provisions',
        vermittlung: 'Changes only in writing. Severability clause. German law applies. Jurisdiction: Freilassing.',
        anu: 'Changes only in writing. Severability clause. German law applies. Jurisdiction: Freilassing.',
      },
    ],
  };

  const labels: Record<string, Record<string, string>> = {
    de: {
      vermittlung: 'Vermittlung (Direktplatzierung)',
      anu: 'Arbeitnehmerüberlassung (ANÜ)',
      version: 'Version',
      effectiveDate: 'Gültig ab',
      print: 'Druckansicht / PDF',
      printHint: 'Für Ablage oder Weitergabe als PDF exportieren',
    },
    bs: {
      vermittlung: 'Posredovanje (Direktna zaposlenja)',
      anu: 'Pozajmljivanje radnika (ANÜ)',
      version: 'Verzija',
      effectiveDate: 'Važi od',
      print: 'Prikaz za štampu / PDF',
      printHint: 'Izvoz u PDF za arhivu ili deljenje',
    },
    en: {
      vermittlung: 'Direct Placement',
      anu: 'Temporary Staffing (ANÜ)',
      version: 'Version',
      effectiveDate: 'Effective from',
      print: 'Print View / PDF',
      printHint: 'Export as PDF for filing or sharing',
    },
  };

  const agbMeta = {
    version: 'v2026-06',
    effectiveDate: '18.06.2026',
  };

  const uiLabels = labels[lang as keyof typeof labels] || labels.de;
  const items = content[lang as keyof typeof content] || content.de;

  return (
    <div className="agb-root min-h-screen bg-gradient-to-b from-background to-muted/30 py-8">
      <style>{`
        .agb-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 2rem;
        }

        .agb-header {
          text-align: center;
          margin-bottom: 3rem;
          padding-bottom: 2rem;
          border-bottom: 2px solid var(--color-border);
        }

        .agb-header h1 {
          font-size: 2.2rem;
          font-weight: 800;
          margin-bottom: 0.75rem;
          color: var(--color-foreground);
        }

        .agb-header p {
          color: var(--color-muted-foreground);
          font-size: 1rem;
          margin-bottom: 1.5rem;
        }

        .agb-meta {
          display: flex;
          justify-content: center;
          gap: 2.5rem;
          font-size: 0.95rem;
          color: var(--color-muted-foreground);
          flex-wrap: wrap;
        }

        .agb-meta span {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .agb-print-controls {
          margin-top: 1rem;
          display: inline-flex;
          flex-direction: column;
          gap: 0.35rem;
          align-items: center;
        }

        .agb-print-button {
          border: 1px solid var(--color-border);
          background: var(--color-card);
          color: var(--color-foreground);
          font-weight: 600;
          font-size: 0.9rem;
          padding: 0.5rem 0.85rem;
          border-radius: 0.4rem;
          cursor: pointer;
        }

        .agb-print-button:hover {
          border-color: var(--color-primary);
          color: var(--color-primary);
        }

        .agb-print-hint {
          color: var(--color-muted-foreground);
          font-size: 0.8rem;
        }

        .agb-columns {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          margin-bottom: 2rem;
        }

        .agb-column {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .agb-column-header {
          padding: 1.75rem;
          background: var(--color-primary);
          color: var(--color-primary-foreground);
          border-radius: 0.5rem;
          font-weight: 800;
          text-align: center;
          font-size: 1.25rem;
          letter-spacing: 0.5px;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
        }

        .agb-section {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          padding-bottom: 1.75rem;
          border-bottom: 1.5px solid var(--color-border);
        }

        .agb-section:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .agb-section-title {
          font-weight: 700;
          color: var(--color-foreground);
          font-size: 1.05rem;
          letter-spacing: 0.3px;
        }

        .agb-section-content {
          color: var(--color-foreground);
          line-height: 1.8;
          font-size: 0.95rem;
        }

        .agb-hinweis {
          background-color: var(--color-primary/8);
          border-left: 4px solid var(--color-primary);
          padding: 1rem 1rem 1rem 1.25rem;
          margin-top: 1rem;
          border-radius: 0.25rem;
          font-style: italic;
          color: var(--color-primary);
          font-size: 0.9rem;
          line-height: 1.7;
        }

        @media (max-width: 768px) {
          .agb-container {
            padding: 1rem;
          }

          .agb-header h1 {
            font-size: 1.75rem;
          }

          .agb-columns {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          .agb-column-header {
            padding: 1.5rem;
            font-size: 1.1rem;
          }

          .agb-meta {
            gap: 1rem;
            flex-direction: column;
          }

          .agb-section {
            padding-bottom: 1.25rem;
          }
        }

        @media print {
          @page {
            size: A4;
            margin: 14mm;
          }

          .agb-root {
            background: #fff !important;
            padding: 0 !important;
          }

          .agb-container {
            max-width: none;
            padding: 0;
          }

          .agb-print-controls {
            display: none !important;
          }

          .agb-header {
            margin-bottom: 8mm;
            padding-bottom: 3mm;
            border-bottom: 1px solid #222;
          }

          .agb-header h1,
          .agb-header p,
          .agb-meta,
          .agb-meta strong,
          .agb-section-title,
          .agb-section-content {
            color: #000 !important;
          }

          .agb-columns {
            display: block;
            margin-bottom: 0;
          }

          .agb-column {
            gap: 0;
            margin-bottom: 10mm;
            page-break-inside: avoid;
            break-inside: avoid-page;
          }

          .agb-column + .agb-column {
            page-break-before: always;
            break-before: page;
          }

          .agb-column-header {
            background: transparent !important;
            color: #000 !important;
            border: 1px solid #222;
            box-shadow: none;
            margin-bottom: 4mm;
          }

          .agb-section {
            border-bottom: 1px solid #ccc;
            padding-bottom: 3.5mm;
            margin-bottom: 3.5mm;
            page-break-inside: avoid;
            break-inside: avoid-page;
          }

          .agb-hinweis {
            background: #f5f5f5 !important;
            color: #000 !important;
            border-left-color: #333;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .agb-footer {
            color: #444 !important;
          }
        }
      `}</style>

      <div className="agb-container">
        <div className="agb-header">
          <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
          <p>ViaMedica Balkan - Personalvermittlung und Arbeitnehmerüberlassung</p>
          <div className="agb-meta">
            <span>
              <strong>{uiLabels.version}:</strong> {agbMeta.version}
            </span>
            <span>
              <strong>{uiLabels.effectiveDate}:</strong> {agbMeta.effectiveDate}
            </span>
          </div>
          <div className="agb-print-controls">
            <button type="button" className="agb-print-button" onClick={() => window.print()}>
              {uiLabels.print}
            </button>
            <p className="agb-print-hint">{uiLabels.printHint}</p>
          </div>
        </div>

        <div className="agb-columns">
          <div className="agb-column">
            <div className="agb-column-header">{uiLabels.vermittlung}</div>
            <div>
              {items.map((item) => (
                <div key={`vermittlung-${item.id}`} className="agb-section">
                  <div className="agb-section-title">{item.title}</div>
                  <div className="agb-section-content">{item.vermittlung}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="agb-column">
            <div className="agb-column-header">{uiLabels.anu}</div>
            <div>
              {items.map((item) => (
                <div key={`anu-${item.id}`} className="agb-section">
                  <div className="agb-section-title">{item.title}</div>
                  <div className="agb-section-content">{item.anu}</div>
                  {item.hinweis && <div className="agb-hinweis">{item.hinweis}</div>}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="agb-footer text-center text-sm text-muted-foreground py-6 border-t border-border">
          <p>© 2026 ViaMedica Balkan. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </div>
  );
};

export default AGBComparisonLayout;
